var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('toggleMenu')}}}),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$router.currentRoute.name))]),_c('v-spacer'),_vm._v(" v0.5.0 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }